import { MultiSelectDropdown } from '../../../components/MultiSelectDropdown/MultiSelectDropdown'
import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useInviteRoleGroups } from '../InviteRoleGroups'
import DatePicker from 'react-datepicker'
import { defaultPendingInvitationsFilter } from './utils'
import { SelectDropdown } from '../../../components/SelectDropdown/SelectDropdown'
import { BaseRoleGroup } from '../../../models/Role'

const _OPTION_ALL = 'all'

const statusOptions = [
  { id: _OPTION_ALL, label: 'All' },
  { id: 'pending', label: 'Pending' },
  { id: 'expired', label: 'Expired' },
]

export interface PendingInvitationFilterModel {
  emailPattern: string | null
  namePattern: string | null
  roleGroups: BaseRoleGroup[]
  status: string | null
  invitationDate: string | null
}

export type OnPendingInvitationFilterChanged = (filter: PendingInvitationFilterModel) => void

export interface PendingInvitationsFilterProps {
  onFilterChanged: OnPendingInvitationFilterChanged
}

export const PendingInvitationsFilter = ({ onFilterChanged }: PendingInvitationsFilterProps) => {
  const [filter, _setFilter] = useState<PendingInvitationFilterModel>(defaultPendingInvitationsFilter)
  const [selectedRoles, setSelectedRoles] = useState<string[]>([])
  const roleGroups = useInviteRoleGroups({ onlyInvitable: true })

  const setFilter = (newFilter: PendingInvitationFilterModel) => {
    _setFilter(newFilter)
    onFilterChanged(newFilter)
  }

  const handleRoleSelectionChanged = (roles: string[]) => {
    setSelectedRoles(roles)
    const selectedRoleGroups = roleGroups
      .filter((roleGroup) => roles.includes(roleGroup.name))
      .map((roleGroup) => ({ name: roleGroup.name, roleIds: roleGroup.roleIds }))
    setFilter({ ...filter, roleGroups: selectedRoleGroups })
  }

  return (
    <div className='d-flex gap-1 w-100'>
      <div className='w-100'>
        Filter by Name
        <Form.Control
          type='text'
          value={filter.namePattern ?? ''}
          onChange={(e) => setFilter({ ...filter, namePattern: e.currentTarget.value.trim() === '' ? null : e.currentTarget.value })}
          placeholder='Name'
        />
      </div>
      <div className='w-100'>
        Filter by Email
        <Form.Control
          type='text'
          value={filter.emailPattern ?? ''}
          onChange={(e) => setFilter({ ...filter, emailPattern: e.currentTarget.value.trim() === '' ? null : e.currentTarget.value })}
          placeholder='Email'
        />
      </div>
      <div className='w-100'>
        Filter by Role
        <MultiSelectDropdown
          name='roles'
          options={roleGroups.map((role) => ({ id: role.name, label: role.name }))}
          initialSelectedOptions={selectedRoles}
          onSelectedChanged={handleRoleSelectionChanged}
        />
      </div>
      <div className='w-100'>
        Filter by Status
        <SelectDropdown
          options={statusOptions}
          initialSelectedOption={
            filter.status ? statusOptions.find((status) => status.id === filter.status) : statusOptions.find((status) => status.id === _OPTION_ALL)
          }
          onOptionSelected={(status) => setFilter({ ...filter, status: status.id === _OPTION_ALL ? null : status.id })}
          disabled={false}
        />
      </div>
      <div className='w-100'>
        Filter by Invitation Date
        <DatePicker
          wrapperClassName='w-100'
          className='form-control zocks-border-color-gray-400'
          maxDate={new Date()}
          selected={filter.invitationDate ? new Date(filter.invitationDate) : null}
          onChange={(date) => setFilter({ ...filter, invitationDate: date ? date.toJSON() : null })}
          isClearable={true}
          placeholderText='Choose date'
          showIcon={filter.invitationDate === null}
          toggleCalendarOnIconClick
          icon='bi bi-calendar4-week'
          calendarIconClassname='email-filter-calendar-icon'
        />
      </div>
    </div>
  )
}
